import { render, staticRenderFns } from "./EditServiceSideBarTabsPaxs.vue?vue&type=template&id=ec9765d8&scoped=true&"
import script from "./EditServiceSideBarTabsPaxs.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsPaxs.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBarTabsPaxs.vue?vue&type=style&index=0&id=ec9765d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9765d8",
  null
  
)

export default component.exports